<div class="pm-user-image-wrapper" (click)="watermarkClick()">
  <div class="synchronize-warning" [ngClass]="offlinePosition" [class.hidden]="!offlineSynchronizing">
    Synchronizing offline fallback
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar> </div>
    @if (hasLogo) {
      <img class="pm-user-logo" [ngClass]="logoPositionClass" [src]="logoSource" [style.width]="logoWidth"
        [class.hidden]="!showLogo" [style.height]="logoHeight" (error)="showLogo = false"
        (load)="showLogo = true">
    }
    @if (hasWatermark) {
      <img class="pm-user-watermark" [src]="watermarkSource" [style.max-width]="watermarkSize"
        [style.max-height]="watermarkSize" [style.opacity]="watermarkOpacity" [class.hidden]="!showWatermark"
        (error)="showWatermark = false" (load)="showWatermark = true">
    }
  </div>
